module.exports = __webpack_public_path__ + "static/media/isabel.899f1eb2.jpg";